<p-drawer
  [visible]="visible()"
  (visibleChange)="onDrawerVisibleChange($event)"
  [position]="drawerPosition()"
  [appendTo]="appendTo()"
  [modal]="!childOverlayOpen()"
  [blockScroll]="!childOverlayOpen()"
  [autoZIndex]="false"
  styleClass="kl-column-settings-drawer-panel"
  [style]="drawerStyle"
  [maskStyle]="drawerMaskStyle"
  [baseZIndex]="11000">
  <ng-template #header>
    <span class="kl-column-settings-drawer__title">{{ drawerHeaderKey() | translate }}</span>
  </ng-template>

  <div class="kl-column-settings-drawer__body">
    @if (hasDesignSaveTarget()) {
      <div
        class="kl-column-settings-drawer__width-edit"
        [class.kl-column-settings-drawer__width-edit--active]="columnWidthEditMode()">
        <p class="kl-column-settings-drawer__width-edit-label">{{ 'column_width_edit_mode' | translate }}</p>
        <p class="kl-column-settings-drawer__width-edit-hint">{{ 'column_width_edit_mode_hint' | translate }}</p>
        <button
          type="button"
          class="kl-form-btn kl-form-btn--sm w-100"
          [class.kl-form-btn--primary]="!columnWidthEditMode()"
          [class.kl-form-btn--secondary]="columnWidthEditMode()"
          (click)="toggleColumnWidthEditMode()">
          <i class="ph me-1" [class.ph-arrows-out-line-horizontal]="!columnWidthEditMode()" [class.ph-check]="columnWidthEditMode()"></i>
          {{
            (columnWidthEditMode() ? 'column_width_edit_mode_done' : 'column_width_edit_mode_start') | translate
          }}
        </button>
      </div>
    }
    @if (showGridDesignTab()) {
      <div class="kl-column-settings-drawer__tabs" role="tablist">
        @for (tab of drawerTabs(); track tab.id) {
          <button
            type="button"
            class="kl-column-settings-drawer__tab"
            role="tab"
            [class.kl-column-settings-drawer__tab--active]="activeDrawerTab() === tab.id"
            [attr.aria-selected]="activeDrawerTab() === tab.id"
            (click)="setDrawerTab(tab.id)">
            {{ tab.labelKey | translate }}
          </button>
        }
      </div>
    }
    @if (!showGridDesignTab() || activeDrawerTab() === 'columns') {
      <ng-container *ngTemplateOutlet="columnSectionTpl" />
    } @else {
      <div class="sidebar-section sidebar-section--design">
        <button
          type="button"
          class="kl-form-btn kl-form-btn--secondary kl-form-btn--sm w-100 mb-2"
          (click)="onResetToDefaultClick()">
          <i class="ph ph-arrow-counter-clockwise me-1"></i>
          {{ 'default_design' | translate }}
        </button>
        <button
          type="button"
          class="kl-form-btn kl-form-btn--primary kl-form-btn--sm w-100 mb-3"
          [disabled]="designSaving()"
          (click)="saveDesign()">
          <i class="ph ph-floppy-disk me-1"></i>
          {{ 'save_design' | translate }}
        </button>
        <div class="sidebar-label">{{ 'saved_designs' | translate }}</div>
        @if (designTemplates().length) {
          <ul class="design-list">
            @for (template of designTemplates(); track template.id; let i = $index) {
              <li
                class="design-item"
                [class.active]="template.id === currentDesignTemplate()?.id"
                (click)="selectDesignTemplate(template)">
                <span class="design-item__name">{{ template.description }}</span>
                @if (canManageDesign(template)) {
                  @if (legacyDesignQueryActive()) {
                    <button
                      type="button"
                      class="design-item__edit"
                      (click)="editDesign(template, $event)"
                      [title]="'edit' | translate">
                      <i class="ph ph-pencil-simple"></i>
                    </button>
                  }
                  <button
                    type="button"
                    class="design-item__delete"
                    (click)="deleteDesign(template, i, $event)"
                    [title]="'delete' | translate">
                    <i class="ph ph-trash"></i>
                  </button>
                }
              </li>
            }
          </ul>
        } @else {
          <p class="sidebar-empty">{{ 'no_data' | translate }}</p>
        }
      </div>
    }
  </div>
</p-drawer>

<ng-template #columnSectionTpl>
  <div class="sidebar-section">
    <div class="sidebar-search">
      <i class="ph ph-magnifying-glass"></i>
      <input
        type="text"
        [placeholder]="'search' | translate"
        [ngModel]="columnSearchText()"
        (ngModelChange)="columnSearchText.set($event)"
        autocomplete="off" />
    </div>
    <div class="sidebar-actions">
      <button type="button" class="sidebar-link-btn" (click)="checkAllColumns()">{{ 'check_all' | translate }}</button>
      <button type="button" class="sidebar-link-btn" (click)="uncheckAllColumns()">
        {{ 'uncheck_all' | translate }}
      </button>
    </div>
    <p class="column-reorder-hint">{{ 'column_drag_to_reorder' | translate }}</p>
    @if (!showGridDesignTab()) {
      <div class="sidebar-reset-default">
        <button type="button" class="sidebar-link-btn" (click)="onResetToDefaultClick()">
          <i class="ph ph-arrow-counter-clockwise"></i>
          {{ 'default_design' | translate }}
        </button>
      </div>
    }
    <div
      class="column-list"
      cdkDropList
      [cdkDropListDisabled]="!!columnSearchText().trim()"
      (cdkDropListDropped)="onColumnDrop($event)">
      @for (col of filteredColumnVisibility(); track col.binding) {
        @if (editingColumnBinding() === col.binding) {
          <div class="column-toggle column-toggle--editing">
            <input
              type="text"
              class="column-label-input"
              [ngModel]="editingColumnLabel()"
              (ngModelChange)="editingColumnLabel.set($event)"
              (keydown.enter)="saveColumnLabel(col.binding)"
              autocomplete="off" />
            <button
              type="button"
              class="column-label-save"
              (click)="saveColumnLabel(col.binding)"
              [title]="'save' | translate">
              <i class="ph ph-check"></i>
            </button>
          </div>
        } @else {
          <label class="column-toggle" cdkDrag [cdkDragDisabled]="!!columnSearchText().trim()">
            <div class="d-flex align-items-center column-toggle__main">
              <i class="ph ph-dots-six-vertical column-drag-handle" cdkDragHandle></i>
              <input
                type="checkbox"
                class="column-toggle__checkbox"
                [checked]="col.visible"
                (change)="toggleColumnVisibility(col.binding)" />
              <span>{{ col.header }}</span>
            </div>
            <i
              class="ph ph-pencil-simple column-label-edit"
              [title]="'edit' | translate"
              (click)="startEditColumnLabel(col); $event.preventDefault(); $event.stopPropagation()"></i>
            @if (showColumnProperties()) {
              <i
                class="ph ph-gear column-properties-edit"
                [title]="'field_properties' | translate"
                (click)="
                  columnPropertiesClick.emit(col.binding); $event.preventDefault(); $event.stopPropagation()
                "></i>
            }
          </label>
        }
      }
    </div>
  </div>
</ng-template>
